import * as React from 'react';
import { MainContext } from './main-page';
const MainPageCore = (props) => {
    const { children, className } = props;
    const BEM = () => {
        const classArray = ['main__page'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("main", { className: BEM(), id: "main-content", tabIndex: -1 },
        React.createElement(MainContext.Provider, { value: { hasMainPageComponent: true } }, children)));
};
export default MainPageCore;
